<span
  [ngClass]="_classes"
  class="material-symbols-outlined"
  [style.font-size.px]="size"
  >{{ _icon }}</span
>
